import React ,{useEffect, useState} from "react";

import classes from './CrazyProject.module.css'

const SecondPage =()=>{
    const[showComponent, setshowComponent]=useState(false)

    useEffect(()=>{
        setInterval(()=>{
            setshowComponent(!showComponent);
        }, 5000)
    })
    return(
        <>
            <div className={classes.secondcontainer}>
                <div className={classes.photo}>
                    <img src={require('../../assets/portfolio/second_container.png')}></img>
                </div>
                <div className={classes.secondLine}></div>
                <div className={classes.desc} style={{fontFamily:"SofiaPro-Light"}}>
                    <p className={classes.bigText}>Self-Custody Crypto Wallet for DFT, NFT and Metaverse</p>
                    <p>Explore the list of 1000s Apps or connect Web3 App with a WalletConnect protocol</p>
                </div>
            </div>
        </> 
    )
 
}

export default SecondPage;